import {
    COMMON_VALUES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_CHARITY_DETAILS,
    GET_CHARITY_DETAILS_BY_ID,
    SEARCH_JUSTGIVING_CHARITY,
} from './commonTypes'

export default (state, action) => {
    switch (action.type) {
        case COMMON_VALUES:
            return {
                ...state,
                ...action.payload,
            }
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_CHARITY_DETAILS:
            return {
                ...state,
                all_charity_details: action.payload,
            }

        case GET_CHARITY_DETAILS_BY_ID:
            return {
                ...state,
                all_charity_details_by_id: action.payload,
            }
        case SEARCH_JUSTGIVING_CHARITY:
            return {
                ...state,
                charityDetails: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
